import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTriggerAcc
} from '@/components/common/Tabs';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InstalledWithin24Hours from './InstalledWithin24Hours';
import InstallationExpired from './InstallationExpired';

export default observer(function NeedArrangedOverdue() {
    // hook
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState<string>('basic');

    // function
    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    return (
        <div>
            <Tabs
                value={activeTab}
                onValueChange={handleTabChange}
                className='w-full'
            >
                <TabsList className='flex justify-start gap-[6px]'>
                    <TabsTriggerAcc value='basic'>
                        {t('dashboard.installed_within_24_hours')}
                    </TabsTriggerAcc>
                    <TabsTriggerAcc value='bike-list'>
                        {t('dashboard.installation_expired')}
                    </TabsTriggerAcc>
                </TabsList>
                <TabsContent value='basic' className='mt-0'>
                    <InstalledWithin24Hours />
                </TabsContent>
                <TabsContent value='bike-list' className='mt-0'>
                    <InstallationExpired />
                </TabsContent>
            </Tabs>
        </div>
    );
});
